/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: false, // Change this to false if you don't want Splash screen.
};

//Home Page
const greeting = {
  title: "Ziad Lrhazouli",
  logo_name: "Ziad Lrhazouli",
  nickname: null,
  subTitle:
    "Accomplished Game Developer specializing in XR with 5+ years of experience.",
  resumeLink:
    "#",
  portfolio_repository: "https://github.com/zxkings",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/zxkings",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/ziad-lrhazouli-90b5201a2",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  // {
  //   name: "YouTube",
  //   link:
  //     "#",
  //   fontAwesomeIcon: "fa-youtube", // Reference https://fontawesome.com/icons/youtube?style=brands
  //   backgroundColor: "#FF0000", // Reference https://simpleicons.org/?q=youtube
  // },
  {
    name: "Gmail",
    link:
      "mailto:lrhazouliziad@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
  // {
  //   name: "Facebook",
  //   link: "#",
  //   fontAwesomeIcon: "fa-facebook-f", // Reference https://fontawesome.com/icons/facebook-f?style=brands
  //   backgroundColor: "#1877F2", // Reference https://simpleicons.org/?q=facebook
  // },
  // {
  //   name: "Instagram",
  //   link: "#",
  //   fontAwesomeIcon: "fa-instagram", // Reference https://fontawesome.com/icons/instagram?style=brands
  //   backgroundColor: "#E4405F", // Reference https://simpleicons.org/?q=instagram
  // },
];

const skills = {
  data: [
    {
      title: "Game Development",
      fileName: "FullStackImg",
      skills: [
        "🎮 Developing immersive VR experiences for standalone (Quest) and PC VR platforms.",
        "🎮 Programming core gameplay mechanics and complex interaction systems in C#.",
        "🎮 Optimizing application performance to achieve high, stable frame rates (90fps).",
        "🎮 Architecting clean, scalable, and maintainable codebases for long-term projects.",
      ],
      softwareSkills: [
        {
          skillName: "Unity",
          fontAwesomeClassname: "simple-icons:unity",

        },
        {
          skillName: "Unreal Engine",
          fontAwesomeClassname: "simple-icons:unrealengine",

        },
        {
          skillName: "Godot",
          fontAwesomeClassname: "skill-icons:godot-dark",
          style: {
            color: "#FFFFFF", // Unity logo is often white on dark backgrounds
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "simple-icons:csharp",
          style: {
            color: "#512BD4",
          },
        },
        {
          skillName: "Oculus",
          fontAwesomeClassname: "simple-icons:oculus",
          style: {
            color: "#2B65E0", // A representative blue
          },
        },
        {
          skillName: "SteamVR",
          fontAwesomeClassname: "simple-icons:steam",
          style: {
            color: "#9099A1",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "Jira",
          fontAwesomeClassname: "simple-icons:jira",
          style: {
            color: "#0052CC",
          },
        },
      ],
    },
  ],
};

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "VR/AR Specialization", // Lead with your key selling point
      progressPercentage: "95%", // Reflects your 5+ years of experience
    },
    {
      Stack: "Gameplay & Interaction Programming", // This is the "frontend" of game dev
      progressPercentage: "90%",
    },
    {
      Stack: "Engine & Systems Development", // This is the "backend" of game dev
      progressPercentage: "85%",
    },
    {
    Stack: "Tools & Pipeline Development", // A senior-level skill showing you improve workflow
      progressPercentage: "75%",    
    },
  ],
};

//Language Skill
const sLanguage = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "C#", // Your primary language for Unity
      progressPercentage: "95%",
    },
        {
      Stack: "Unreal Blueprints", // Crucial for working in Unreal Engine
      progressPercentage: "70%",
    },
    {
      Stack: "C++", // Essential for Unreal Engine and high-performance code
      progressPercentage: "65%",
    },
    {
      Stack: "GDScript", // For Godot, shows versatility
      progressPercentage: "50%",
    },
  ],
};

//Tools Skill
const tools = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Unity",
      progressPercentage: "95%",
    },
        {
      Stack: "Oculus (Meta) SDK", // Specific VR toolkit
      progressPercentage: "95%",
    },
    {
      Stack: "jetbrains Rider", // Your main coding environments
      progressPercentage: "95%",
    },
    {
      Stack: "Git", // Essential for any developer
      progressPercentage: "90%",
    },
    {
      Stack: "SteamVR SDK", // The other major VR toolkit
      progressPercentage: "70%",
    },
    {
      Stack: "Unreal Engine",
      progressPercentage: "50%",
    },
    {
      Stack: "Godot Engine",
      progressPercentage: "20%",
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Codechef",
      iconifyClassname: "simple-icons:codechef",
      style: {
        color: "#5B4638",
      },
      profileLink: "https://www.codechef.com/users/tasin95",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "Ahsanullah University of Science and Technology",
      subtitle: "B.Sc. in Computer Science and Engineering",
      logo_path: "aust_logo.png",
      alt_name: "IIITDM Kurnool",
      duration: "March 2016 - January 2021",
      cgpa: "3.855 / 4.00",
      descriptions: [
        "⚡ I have studied basic software engineering subjects like DS, Algorithms, OOP, DBMS, OS, CA, AI etc.",
        "⚡ Apart from this, I have done courses on Deep Learning and Full Stack Development.",
        "⚡ Placed 4th in my class.",
        "⚡ Dean's List.",
        "⚡ I was selected for ITEE Training Program which comprised of 20 students in the CSE department.",
        "⚡ Elected as the team leader in all the group projects.",
      ],
      website_link: "http://aust.edu/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      // This is your official, most important certification.
      title: "Unity Certified User: Programmer",
      subtitle: "Certiport - A Pearson VUE Business",
      logo_path: "Unity certified Programmer.png", // You will need to find and add this logo to your assets.
      // IMPORTANT: Replace "#" with the actual "Show credential" link from your LinkedIn/Certiport profile.
      certificate_link: "https://www.credly.com/badges/1462347a-c6cb-4ee9-aba1-ba3fb99b3f62/", 
      alt_name: "Certiport",
      color_code: "#42A5F5", // A blue matching Certiport's branding
    },
    {
      // This is your official, most important certification.
      title: "VR Specialist",
      subtitle: "Certiport - A Pearson VUE Business",
      logo_path: "VR_Specialist_Badge.png", // You will need to find and add this logo to your assets.
      // IMPORTANT: Replace "#" with the actual "Show credential" link from your LinkedIn/Certiport profile.
      certificate_link: "https://www.credly.com/badges/1462347a-c6cb-4ee9-aba1-ba3fb99b3f62/", 
      alt_name: "Certiport",
      color_code: "#42A5F5", // A blue matching Certiport's branding
    },
    {
      // This is your official, most important certification.
      title: "Unity Certified User: VR Developer",
      subtitle: "Certiport - A Pearson VUE Business",
      logo_path: "Unity Certified VR Developer.png", // You will need to find and add this logo to your assets.
      // IMPORTANT: Replace "#" with the actual "Show credential" link from your LinkedIn/Certiport profile.
      certificate_link: "https://www.credly.com/badges/1462347a-c6cb-4ee9-aba1-ba3fb99b3f62/", 
      alt_name: "Certiport",
      color_code: "#42A5F5", // A blue matching Certiport's branding
    },
    
    // {
    //   // This demonstrates your core engine expertise.
    //   title: "Advanced C# & Unity Game Performance Optimization",
    //   subtitle: "Unity Learn Premium",
    //   logo_path: "unity_logo.png", // You will need to find and add this logo.
    //   certificate_link: "#", // Placeholder for a relevant course you have taken or will take.
    //   alt_name: "Unity",
    //   color_code: "#FFFFFF",
    // },
    // {
    //   // This shows your versatility and knowledge of other major engines.
    //   title: "Unreal Engine 5 VR Development Fundamentals",
    //   subtitle: "Epic Games Learning",
    //   logo_path: "unreal_engine_logo.png", // You will need to find and add this logo.
    //   certificate_link: "#", // Placeholder
    //   alt_name: "Unreal Engine",
    //   color_code: "#313131",
    // },
    // {
    //   // This is a senior-level skill that sets you apart.
    //   title: "Introduction to Shader Programming in Unity",
    //   subtitle: "Coursera / Udemy",
    //   logo_path: "coursera_logo.png", // Or a generic "learning" icon.
    //   certificate_link: "#", // Placeholder
    //   alt_name: "Online Course",
    //   color_code: "#0056D2",
    // },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Professional Work History",
  description:
    "Accomplished Team Lead and Senior VR Developer with over 4 years of experience leading teams and architecting immersive applications for standalone VR platforms. Proven ability to manage the full project lifecycle, from concept to deployment, while mentoring developers and ensuring high standards for code quality and performance.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Work",
      experiences: [
        {
          title: "Team Lead Manager",
          company: "Octav",
          company_url: "https://octav.studio/",
          logo_path: "O__logo_DK.png",
          duration: "June 2021 - Present",
          location: "Marrakech, Morocco",
          description:
            "Led a dedicated team of VR developers in the creation of high-quality interactive experiences and games. Responsible for technical architecture, project planning, team management, and ensuring all projects met performance targets on standalone VR hardware.",
          features: [
            "- Led a team of 4 VR developers, improving project delivery timelines by 20% through agile methodologies and clear communication.",
            "- Architected the core systems for 5+ commercial VR applications, focusing on creating scalable, reusable, and high-performance code.",
            "- Successfully optimized multiple projects for the Meta Quest 2, Meta quest Pro, Meta quest 3 and Pico 4, consistently achieving the target 90fps for a smooth and comfortable user experience.",
            "- Mentored junior developers in best practices for VR development, including performance profiling, version control (Git), and code review.",
            "- Managed the full development lifecycle, from initial prototyping and client pitches to final deployment on platforms like the Oculus Store and SteamVR.",
          ],
          // A professional, dark color that will work well with a dark logo.
          color: "#282c34",
        },
      ],
    },
    // The "Volunteerships" section has been completely removed.
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "I specialize in crafting immersive and interactive XR experiences, from high-fidelity training simulations to engaging educational applications. Leveraging the power of Unity and C#, I build solutions that solve real-world problems and bring complex ideas to life in virtual and augmented reality.",
  avatar_image_path: "projects_image.svg",
};

// In portfolio.js

const manualProjects = {
  projects: [
    {
      id: "vr-crane-sim",
      title: "Crane Simulation",
      description: "Developed a sophisticated VR training simulation for port crane operators, creating an immersive and realistic virtual environment that precisely replicates port conditions.",
      technologies: ["Unity", "C#", "Oculus SDK", "VR"],
    },
    {
      id: "curio-xr",
      title: "Curio XR",
      description: "Contributed to an educational VR/AR platform featuring controller-free navigation, an interactive whiteboard, and an AI study assistant for subjects like anatomy and chemistry.",
      technologies: ["Unity", "C#", "AR", "VR"],
    },
    {
      id: "emergencia-vr",
      title: "Emergencia VR",
      description: "Developed a high-stakes medical VR simulation placing the user in the role of an ER doctor, requiring rapid testing, analysis, and medical procedures.",
      technologies: ["Unity", "C#", "VR", "Medical"],
    },
    {
      id: "the-vault-xr",
      title: "The Vault",
      description: "Created a specialized XR medical training app for practicing the precise manipulation of secure medical vaults, featuring realistic hand-gesture controls and haptic feedback.",
      technologies: ["Unity", "C#", "XR", "Medical"],
    },
    {
      id: "riad-vr",
      title: "Riad VR",
      description: "Led the development of a VR cultural heritage experience, meticulously recreating a traditional Moroccan Riad with high-fidelity visual detail to immerse users in architectural elegance.",
      technologies: ["Unity", "C#", "VR", "Arch-Viz"],
    },
    {
      id: "chemistry-vr",
      title: "ChemistryVR",
      description: "Built an educational VR app allowing students to visualize and interact with molecules in 3D, constructing structures and observing reactions to make abstract concepts tangible.",
      technologies: ["Unity", "C#", "VR", "Education"],
    },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "profile circle 400x400.png", // IMPORTANT: Change this to the name of your profile picture in the assets folder.
    description:
      "I'm always open to discussing new projects, freelance opportunities, and collaborations in the XR space. If you're looking for a developer to help build your next immersive training simulation, educational app, or interactive experience, please feel free to reach out.",
  },
  blogSection: {
    title: "Projects Showcase",
    subtitle:
      "For a more in-depth look at my work, including development processes and technical challenges, you can explore my project case studies.",
    // IMPORTANT: Link this to your portfolio's project page or a platform like ArtStation/GitHub.
    link: "#", 
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Location",
    subtitle: "Morocco", // Professional and safe for a public portfolio.
    avatar_image_path: "address_image.svg",
    location_map_link: "https://www.google.com/maps/place/Morocco",
  },
  phoneSection: {
    title: "Preferred Contact",
    // IMPORTANT: Replace this with your professional email address.
    subtitle: "lrhazouliziad@gmail.com", 
  },
};

export {
  settings,
  greeting,
  socialMediaLinks,
  skills,
  techStack,
  sLanguage,
  tools,
  competitiveSites,
  degrees,
  certifications,
  experience,
  manualProjects,
  projectsHeader,
  contactPageData,
};
